import React from 'react';
import { Button } from 'antd';
import { CheckSquareOutlined } from '@ant-design/icons';
import { history, useIntl } from '@umijs/max';
import { WorkBadge } from './WorkBadge';
import { useWorkItemsStore } from '@/stores/workItemsStore';

export const WorkItemsEntry: React.FC = () => {
  const intl = useIntl();
  const summary = useWorkItemsStore((state) => state.summary);
  const total = summary?.enabled ? summary.totals.actionCount : 0;
  const label = intl.formatMessage({ id: 'workItems.entry', defaultMessage: '我的待辦' });
  if (!summary?.enabled || !summary.pages.length) return null;
  return (
    <Button
      type="text"
      icon={<CheckSquareOutlined />}
      onClick={() => history.push('/work-items')}
      aria-label={label}
    >
      <WorkBadge count={total} selected={history.location.pathname === '/work-items'}>
        {label}
      </WorkBadge>
    </Button>
  );
};
